
import { ExtraFieldTextConfig } from "@/models/dossier-configs/extra-field-text-config";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		value: {
			type: String,
			default: ""
		}
	},
	computed: {
		items():ISelectItem<string>[]{
			return ExtraFieldTextConfig.metadataToSelectItemList(this.value);
		}
	},
	methods: {
		listToText(val:ISelectItem<string>[]):string{
			return val.map(v=>`${v.text}=${v.value}`).join("\n");
		},
		onTextInput(i:number, value:string){
			let val = ExtraFieldTextConfig.metadataToSelectItemList(this.value);;
			val[i].text = value;
			this.$emit("input", this.listToText(val));
		},
		onValueInput(i:number, value:string){
			let val = ExtraFieldTextConfig.metadataToSelectItemList(this.value);;
			val[i].value = value;
			this.$emit("input", this.listToText(val));
		},
		onValueAdd(){
			let val = ExtraFieldTextConfig.metadataToSelectItemList(this.value);;
			val.push({text: "",  value: ""});
			this.$emit("input", this.listToText(val));
		},
		onValueRemove(i:number){
			let val = ExtraFieldTextConfig.metadataToSelectItemList(this.value);;
			val.splice(i, 1);
			this.$emit("input", this.listToText(val));
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
